import React from 'react'
import { shallow } from 'enzyme'
import { ReferralFee } from '../ReferralFee'
import SuccessNotification from '../../common/SuccessNotification'
import Modal from "../../common/Modal";

jest.useFakeTimers()

describe('<ReferralFee />', () => {
  let wrapper, props, instance
  beforeAll(() => {
    props = {
      loanId: 123,
      documentId: null,
      referralAdjustment: 10,
      documentStatus: null,
      superUser: false,
      referralFeeOn: true
    }
    wrapper = shallow(<ReferralFee {...props} />)
    instance = wrapper.instance()
  })

  describe('#getShowAddDocument', () => {
    describe('when the documentId is null', () => {
      it('returns the showAddDocument value', () => {
        expect(instance.getShowAddDocument(props.documentId)).toBeTruthy()
      })
    })

    describe('when the documentId is not null', () => {
      it('returns the showAddDocument value', () => {
        props.documentId = 123
        wrapper.setProps({ ...props })
        expect(instance.getShowAddDocument(props.documentId)).toBeFalsy()
      })
    })
  })

  describe('#getShowEditFee', () => {
    describe('when the superUser is false', () => {
      describe('when the documentStatus is not approve_and_commit', () => {
        it('returns the showEdit value', () => {
          expect(instance.getShowEditFee(props.documentStatus)).toBeFalsy()
        })
      })

      describe('when the documentStatus is approve_and_commit', () => {
        it('returns the showEdit value', () => {
          props.documentStatus = 'approve_and_commit'
          wrapper.setProps({ ...props })
          expect(instance.getShowEditFee(props.documentStatus)).toBeFalsy()
        })
      })
    })

    describe('when the superUser is true', () => {
      beforeAll(() => {
        props.superUser = true
        props.documentStatus = null
        wrapper.setProps({ ...props })
      })
      describe('when the documentStatus is not approve_and_commit', () => {
        it('returns the showEdit value', () => {
          expect(instance.getShowEditFee(props.documentStatus)).toBeFalsy()
        })
      })

      describe('when the documentStatus is approve_and_commit', () => {
        it('returns the showEdit value', () => {
          props.documentStatus = 'approve_and_commit'
          wrapper.setProps({ ...props })
          expect(instance.getShowEditFee(props.documentStatus)).toBeTruthy()
        })
      })
    })
  })

  describe('#closeSuccessNotification', () => {
    it('changes the isSuccessNotificationVisible state to false', () => {
      wrapper.setState({isSuccessNotificationVisible: true})
      instance.closeSuccessNotification()
      expect(wrapper.state().isSuccessNotificationVisible).toBeFalsy()
    })
  })

  describe('#flashSuccessNotification', () => {
    let msg = 'this is flashSuccessNotification test'
    beforeEach(() => {
      wrapper.setState({
        notificationText: '',
        isSuccessNotificationVisible: false
      })
    })

    it('changes the values of isSuccessNotificationVisible and notificationText', () => {
      instance.flashSuccessNotification(msg)
      expect(wrapper.state().notificationText).toBe(msg)
      expect(wrapper.state().isSuccessNotificationVisible).toBeTruthy()
    })

    it('calls the closeSuccessNotification function with a timeout', () => {
      instance.flashSuccessNotification(msg)
      expect(setTimeout).toHaveBeenCalledWith(instance.closeSuccessNotification, 4000);
    })
  })

  describe('#handleDocumentSuccess', () => {
    let store, documentData
    beforeAll(() => {
      store = {
        readQuery: () => {
          return {}
        },
        writeQuery: () => {
          return true
        }
      }
      documentData = {
        rid: 1,
        status: 'approve_and_commit'
      }
    })

    it('changes the values of documentStatus and showAddDocument', () => {
      instance.handleDocumentSuccess(documentData, store)
      expect(wrapper.state().showAddDocument).toBeFalsy()
      expect(wrapper.state().showEditFee).toBeTruthy()
    })

    it('calls flashes a message', () => {
      const msg = 'Referral fee discount document bucket created, go to business documents section to upload it'
      instance.flashSuccessNotification = jest.fn()
      instance.handleDocumentSuccess(documentData, store)
      expect(instance.flashSuccessNotification).toHaveBeenCalledWith(msg);
    })
  })

  describe('#renderSuccessNotification', () => {
    describe('when isSuccessNotificationVisible is true', () => {
      it('should render a <SuccessNotification />', () => {
        wrapper.setState({ isSuccessNotificationVisible: true })
        expect(wrapper.find(SuccessNotification)).toHaveLength(1)
      })
    })

    describe('when isSuccessNotificationVisible is false', () => {
      it('should not render a <SuccessNotification />', () => {
        wrapper.setState({ isSuccessNotificationVisible: false })
        expect(wrapper.find(SuccessNotification)).toHaveLength(0)
      })
    })
  })

  describe('#editShowEditInput', () => {
    it('changes the showEditInput state to true', () => {
      wrapper.setState({ showEditInput: false })
      instance.editShowEditInput(true)
      expect(wrapper.state().showEditInput).toBeTruthy()
    })

    it('changes the showEditInput state to false', () => {
      wrapper.setState({ showEditInput: true })
      instance.editShowEditInput(false)
      expect(wrapper.state().showEditInput).toBeFalsy()
    })
  })

  describe('#renderFeeInput', () => {
    describe('when showEditInput is true', () => {
      it('should render an <Input/> and 2 <button/>', () => {
        wrapper.setState({ showEditInput: true })
        expect(wrapper.find('#dollarAdjustment')).toHaveLength(1)
        expect(wrapper.find('.icon-remove')).toHaveLength(1)
        expect(wrapper.find('.icon-ok')).toHaveLength(1)
      })
    })

    describe('when showEditInput is false', () => {
      it('should not render an <Input/> and 2 <button/>', () => {
        wrapper.setState({ showEditInput: false })
        expect(wrapper.find('#dollarAdjustment')).toHaveLength(0)
        expect(wrapper.find('.icon-remove')).toHaveLength(0)
        expect(wrapper.find('.icon-ok')).toHaveLength(0)
      })
    })
  })

  describe('#showConfirmationPopup', () => {
    it('changes the showEditInput state to true', () => {
      wrapper.setState({ showEditFeeModal: false })
      instance.showConfirmationPopup()
      expect(wrapper.state().showEditFeeModal).toBeTruthy()
    })
  })

  describe('#updateDollarAdjustment', () => {
    it('updates the ', () => {
      const value = 4
      const event = { target: { value: value } }
      instance.updateDollarAdjustment(event)
      expect(wrapper.state().dollarAdjustment).toBe(value)
    })
  })

  describe('#closeFeeDiscountModal', () => {
    it('modifies the values to close the modal', () => {
      instance.closeFeeDiscountModal()
      expect(wrapper.state().showEditFeeModal).toBeFalsy()
      expect(wrapper.state().errorMessage).toBe('')
      expect(wrapper.state().showEditFeeModal).toBeFalsy()
    })
  })

  describe('#handleLoanAdjustmentSuccess', () => {
    it('finishes the call and returns a message', () => {
      const msg = 'Referral fee applied'
      const dollarAdjustment = 400
      instance.handleLoanAdjustmentSuccess({ dollarAdjustment: dollarAdjustment })
      expect(wrapper.state().referralAdjustment).toBe(dollarAdjustment)
      expect(instance.flashSuccessNotification).toHaveBeenCalledWith(msg)
      expect(wrapper.state().showEditFeeModal).toBeFalsy()
      expect(wrapper.state().errorMessage).toBe('')
      expect(wrapper.state().showEditFeeModal).toBeFalsy()
    })
  })

  describe('#renderConfirmationModal', () => {
    describe('when the showEditFeeModal is true', () => {
      it('should render a <Modal>', () => {
        wrapper.setState({ showEditFeeModal: true })
        expect(wrapper.find(Modal)).toHaveLength(1)
        expect(wrapper.find('.btn-gray')).toHaveLength(1)
        expect(wrapper.find('.btn-default')).toHaveLength(1)
      })
    })

    describe('when the showEditFeeModal is false', () => {
      it('should not render a <Modal>', () => {
        wrapper.setState({ showEditFeeModal: false })
        expect(wrapper.find(Modal)).toHaveLength(0)
      })
    })
  })
})
